import React from 'react';

const End = () => {
    return (
        <div>
            <h1>Quiz is Over </h1>
        </div>
    );
};

export default End;